import { User } from "../../types/user";
import api from "../axiosConfig";
import { Params } from "../../types/pagination";

export const createUser = async (data: User) => {
  try {
    const response = await api.post("/users", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUsers = async (data?: Params) => {
  try {
    const response = await api.get("/users", {
      params: data || {},
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUser = async (id: string) => {
  try {
    const response = await api.get(`/users/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserById = async (id: string, data: User) => {
  try {
    const response = await api.patch(`/users/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const deleteUserById = async (id: string) => {
  try {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getProfile = async () => {
  try {
    const response = await api.get("/profiles");
    return response.data;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};

export const requestPasswordChange = async () => {
  try {
    const response = await api.post("/profiles/request-password-change");
    return response.data;
  } catch (error) {
    console.error("Error: ", error);
    throw error;
  }
};

export const changePassword = async (data?: any) => {
  try {
    const response = await api.post("/profiles/password", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const editProfile = async (data?: any) => {
  try {
    const response = await api.patch("/profiles", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
